import * as types from "../../mutation-types";
import {addOrUpdateItem, removeItem} from "../../helpers";

export default {
    // [types.SET_USERS]: (state, users) => Vue.set(state, 'items', users),
    [types.SET_USERS]: (state, users) => state.items = users,
    [types.ADD_OR_UPDATE_USER]: (state, user) => addOrUpdateItem(state, user),
    [types.REMOVE_USER]: (state, item) => removeItem(state, item),
    [types.SET_USER_SETTING]: (state, {setting, value}) => state.settings[setting] = value
}
